import { Tab, Tabs } from "@material-ui/core";
import React  from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    tab: {
        minWidth: '170px',
        width: '140px'
    },
    tabs: {
      "& .MuiTab-wrapper": {
        alignItems: "flex-start",
        textAlign: "left"
      }
    }
  }));

export default function CustomTabs(props) {
    const classes = useStyles();
    return(
        <div css="margin-left: 20px">
            <Tabs
                value={props.value}
                indicatorColor="primary"
                textColor="primary"
                onChange={(event, newValue) => props.onTabChange(event, newValue)}
                variant="scrollable"
                scrollButtons="auto"
                orientation={props.orientation}
            >
                {
                    (props.tabs.length && props.showTabs) ?
                    props.tabs.map((tab, index) => (
                        <Tab key={index} label={tab.label} disabled={tab.disabled} classes={props.section == "small" ? { root: classes.currentTab} : { root: classes.tab}} className={props.orientation == "vertical" ? classes.tabs: null}/> 
                    ))
                    : null
                }
            </Tabs>
                {
                    props.children ? 
                    props.children : null
                }
        </div>
    )

}